import type { AlertColor } from '@mui/material/Alert';
import { MINIMUM_ESTIMATED_REACH } from '@openx/utils/services/config.ts';

export const calculateSeverity = (
  reach: number | null | undefined,
  numOfSeeds: number,
  estimatedReachLoading: boolean
): AlertColor => {
  if (estimatedReachLoading || reach == null || numOfSeeds === 0) {
    return 'info';
  }

  if (reach < MINIMUM_ESTIMATED_REACH) {
    return 'error';
  }

  return 'success';
};
